import React from 'react';
import {
  AppBar, Box, Divider, Drawer, IconButton, List, ListItemButton,
  ListItemIcon, ListItemText, Toolbar, Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../App';
import { mainListItems } from './listItems';

const drawerWidth = 250;

export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const title = mainListItems.find((item) => item.path === location.pathname)?.label ?? 'Kundenbereich';

  const drawerContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Toolbar sx={{ px: 3 }}>
        <Typography variant="h4" sx={{ color: 'primary.main', fontStyle: 'italic', fontWeight: 800 }}>
          caix
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ ml: 1.5 }}>Kundenportal</Typography>
      </Toolbar>
      <Divider />
      <List sx={{ px: 1.5, py: 2, flexGrow: 1 }}>
        {mainListItems.map(({ label, path, icon: Icon }) => (
          <ListItemButton
            key={path}
            selected={location.pathname === path}
            onClick={() => {
              navigate(path, path === '/bestellung' ? { state: { reopenOrderChoice: true } } : undefined);
              setMobileOpen(false);
            }}
            sx={{ borderRadius: 2, mb: 0.5 }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}><Icon /></ListItemIcon>
            <ListItemText primary={label} />
          </ListItemButton>
        ))}
      </List>
      <Divider />
      <List sx={{ px: 1.5, py: 1 }}>
        <ListItemButton onClick={() => { logout(); navigate('/login'); }} sx={{ borderRadius: 2 }}>
          <ListItemIcon sx={{ minWidth: 40 }}><LogoutIcon /></ListItemIcon>
          <ListItemText primary="Abmelden" />
        </ListItemButton>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'grey.50' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(true)} sx={{ mr: 2, display: { sm: 'none' } }} aria-label="Menü öffnen">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="h1">{title}</Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{ display: { xs: 'block', sm: 'none' }, '& .MuiDrawer-paper': { width: drawerWidth } }}
      >
        {drawerContent}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{ display: { xs: 'none', sm: 'block' }, width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' } }}
      >
        {drawerContent}
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: { xs: 2, sm: 4 } }}>
        <Toolbar />
        <Box sx={{ maxWidth: location.pathname === '/dashboard' ? 'none' : 1200, mx: 'auto' }}><Outlet /></Box>
      </Box>
    </Box>
  );
}
